import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import Dropdown from '@cas/components/inputs/dropdown/Dropdown';
import { AssetApprovalActionModel } from '@casops/store/apis/assetApprovalsApi';
import { VdsField } from '@volt/volt-extended-components-react';
import { ReactElement, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const useConflictResolutionOptions = (
  availableActions: AssetApprovalActionModel[],
): DropdownItemProps<number | null>[] => {
  const { t } = useTranslation();

  const items = useMemo<DropdownItemProps<number | null>[]>(() => {
    return availableActions.map(({ id, action, an }: AssetApprovalActionModel) => {
      const stringValue = id.toString();

      return {
        key: stringValue,
        value: id,
        stringValue: stringValue,
        label: t(`ConflictResolutionOption.${action}`, { assetName: an }),
      };
    });
  }, [t, availableActions]);

  return items;
};

interface ConflictResolutionDropdownProps {
  actions: AssetApprovalActionModel[];
  value: number | null;
  onChange: (value: number | null) => void;
}

export const ConflictResolutionDropdown = ({
  actions,
  value,
  onChange,
}: ConflictResolutionDropdownProps): ReactElement => {
  const { t } = useTranslation();

  const items = useConflictResolutionOptions(actions);

  return (
    <VdsField label={t('Fields.ConflictResolutionOptions')} style={{ width: '100%' }}>
      <Dropdown<number | null>
        uid="conflict-resolution-dropdown"
        value={value}
        placeholder={t('Select')}
        items={items}
        onChange={onChange}
      />
    </VdsField>
  );
};

export default ConflictResolutionDropdown;
